import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Auth from './pages/Auth'
import Landing from './pages/Landing'
import Layout from './pages/Layout'
import Projects from './pages/Projects'
import ProjectView from './pages/ProjectView'
import Settings from './pages/Settings'
import PrivacyPolicy from './pages/PrivacyPolicy'
import LegalPage from './pages/LegalPage'
import Plans from './pages/Plans'
import ContactUs from './pages/ContactUs'
import UseCases from './pages/UseCases'
import IntegrationsPage from './pages/IntegrationsPage'
import IntegrationsCallback from './pages/IntegrationsCallback'
import CookieConsent from './components/CookieConsent'
import { RoutesEnum } from './lib/routes'

function App() {
  return (
    <>
    <Routes>
      <Route path={RoutesEnum.ROOT} element={<Layout />}>
        <Route index element={<Landing />} />
      </Route>
      <Route path={RoutesEnum.AUTH} element={<Layout />}>
        <Route index element={<Auth />} />
      </Route>
      <Route path={RoutesEnum.APP} element={<Layout />}>
        <Route index element={<Projects />} />
        <Route path='p/:id' element={<ProjectView />} />
      </Route>
      <Route path={RoutesEnum.SETTINGS} element={<Layout />}>
        <Route index element={<Settings />} />
        <Route path='integrations' element={<IntegrationsPage />} />
        <Route path='integrations/callback' element={<IntegrationsCallback />} />
      </Route>
      <Route path={RoutesEnum.PRIVACY} element={<Layout />}>
        <Route index element={<PrivacyPolicy />} />
      </Route>
      <Route path={RoutesEnum.TERMS} element={<Layout />}>
        <Route index element={<LegalPage docKey='termsPage' />} />
      </Route>
      <Route path={RoutesEnum.CONSENT} element={<Layout />}>
        <Route index element={<LegalPage docKey='consentPage' />} />
      </Route>
      <Route path={RoutesEnum.COOKIES} element={<Layout />}>
        <Route index element={<LegalPage docKey='cookiePage' />} />
      </Route>
      <Route path={RoutesEnum.PLANS} element={<Layout />}>
        <Route index element={<Plans />} />
      </Route>
      <Route path={RoutesEnum.CONTACT} element={<Layout />}>
        <Route index element={<ContactUs />} />
      </Route>
      <Route path={RoutesEnum.USE_CASES} element={<Layout />}>
        <Route index element={<UseCases />} />
      </Route>
      <Route path='*' element={<Navigate to={RoutesEnum.ROOT} replace />} />
    </Routes>
    <CookieConsent />
    </>
  )
}

export default App
